import { render, staticRenderFns } from "./Paymentterm.vue?vue&type=template&id=4bfccdeb&scoped=true"
import script from "./Paymentterm.vue?vue&type=script&lang=js"
export * from "./Paymentterm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfccdeb",
  null
  
)

export default component.exports